import { Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { PermissionsStoreService } from '../../service/permissions/permissions-store.service';
import { AssessmentsService } from '../../service/entity-services/assessments.service';
import { Assessment } from '../../objects/assessment';

@Component({
  selector: 'app-assessment-connections',
  templateUrl: './assessment-connections.component.html',
  styleUrls: ['./assessment-connections.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    MatChipsModule,
    MatProgressSpinnerModule,
    DatePipe
  ]
})
export class AssessmentConnectionsComponent implements OnChanges {
  private assessmentsService = inject(AssessmentsService);
  private router = inject(Router);

  @Input() entityId = '';
  @Input() entityType = '';
  @Input() sourceRecord = '';

  displayedColumns = ['name', 'type', 'status', 'assessor', 'totalScore', 'criticalDate'];
  readonly isViewer = inject(PermissionsStoreService).isViewer;
  loadError: string | null = null;
  assessments: Assessment[] = [];
  loading = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['entityId'] && this.entityId) {
      this.loadAssessments();
    }
  }

  private loadAssessments(): void {
    this.loading = true;
    this.loadError = null;
    this.assessmentsService.getAssessmentsByEntityId(this.entityId).subscribe({
      next: (assessments) => {
        this.assessments = assessments;
        this.loading = false;
      },
      error: (err) => {
        this.assessments = [];
        this.loadError = this.assessmentsService.describeError(err);
        this.loading = false;
      }
    });
  }

  getAssessorName(assessor: any): string {
    if (!assessor) return '';
    if (typeof assessor === 'string') return assessor;
    return assessor.shortFriendlyName || assessor.email || assessor.name || '';
  }

  totalScore(a: Assessment): string {
    const total = a.totalScore ?? this.assessmentsService.sumScores(a.questionsAndAnswers);
    return a.questionsAndAnswers?.length || a.totalScore != null ? String(total) : '—';
  }

  formatScore(score: number | undefined): string {
    if (score === undefined || score === null) return '—';
    return score.toFixed(1);
  }

  viewAssessment(assessment: Assessment): void {
    this.router.navigate(['/securehome/assessment', assessment.assessmentNum]);
  }

  createAssessment(): void {
    this.router.navigate(['/securehome/new-assessment'], {
      queryParams: {
        entityType: (this.entityType || '').toLowerCase(),
        entityId: this.entityId,
        sourceRecord: this.sourceRecord
      }
    });
  }
}
